import { InjectionToken } from '@angular/core';

import type { FeatureSpec } from '@recruitee/feature-spec-types';

export type FeatureSpecEntity = FeatureSpec[];

export type FeatureSpecMap = Record<FeatureSpec['codename'], FeatureSpec>;

export type FeatureSpecFetchResponse = {
  features: FeatureSpec[];
};

export const FEATURE_SPEC = new InjectionToken<FeatureSpec[]>('FEATURE_SPEC');
